import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SvgIcon from '@material-ui/core/SvgIcon';
import styled from 'styled-components';
import translations from './translations';

const PaginationContainer = styled.div`
  flex-shrink: 0;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    margin-left: ${props => props.theme.spacing(2.5)}px;
  }
`;

const PaginationActions = ({
  count,
  page,
  rowsPerPage,
  onChangePage,
  itemCount,
  getNextPageCursor,
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const nextPageCursor = getNextPageCursor();

  /**
   * Handle the click on the previous page button.
   * @param {Event} event
   */
  const handlePreviousButtonClick = event => {
    onChangePage(event, page - 1);
  };

  /**
   * Handle the click on the next page button
   * @param {Event} event
   */
  const handleNextButtonClick = event => {
    onChangePage(event, page + 1);
  };

  const hasNoCount = itemCount === undefined && nextPageCursor === undefined;
  const nextPageDisabled =
    itemCount !== undefined ? page >= Math.ceil(count / rowsPerPage) - 1 : hasNoCount;

  return (
    <PaginationContainer>
      <IconButton
        onClick={handlePreviousButtonClick}
        disabled={page === 0}
        aria-label={intl.formatMessage(translations.pagination.previousPageLabel)}
        color="inherit"
      >
        {theme.direction === 'rtl' ? (
          <SvgIcon>
            <FontAwesomeIcon fixedWidth icon={['fal', 'angle-right']} />
          </SvgIcon>
        ) : (
          <SvgIcon>
            <FontAwesomeIcon fixedWidth icon={['fal', 'angle-left']} />
          </SvgIcon>
        )}
      </IconButton>
      <FormattedMessage {...translations.pagination.currentPageLabel} values={{ page: page + 1 }} />
      <IconButton
        onClick={handleNextButtonClick}
        disabled={nextPageDisabled}
        aria-label={intl.formatMessage(translations.pagination.nextPageLabel)}
        color="inherit"
      >
        {theme.direction === 'rtl' ? (
          <SvgIcon>
            <FontAwesomeIcon fixedWidth icon={['fal', 'angle-left']} />
          </SvgIcon>
        ) : (
          <SvgIcon>
            <FontAwesomeIcon fixedWidth icon={['fal', 'angle-right']} />
          </SvgIcon>
        )}
      </IconButton>
    </PaginationContainer>
  );
};

PaginationActions.propTypes = {
  count: PropTypes.number,
  itemCount: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onChangePage: PropTypes.func,
  getNextPageCursor: PropTypes.func,
};

PaginationActions.defaultProps = {
  count: 0,
  itemCount: undefined,
  page: 0,
  rowsPerPage: 25,
  onChangePage: undefined,
  getNextPageCursor: undefined,
};

export default PaginationActions;
